import { IQuickTimeSlot } from '@jooxter/utils';
import { JSX, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import JxtSmartSlotSelector from '../JxtSmartSlotSelector';
import { IJxtSmartSlotContainer, JxtSmartSlotContainerGapEnum } from './types';
import { getJxtSmartSlotSelectorContainerClass } from './styles';
import { isSlotSelected } from './helpers';
import JxtLoader from '../JxtLoader';

const JxtSmartSlotSelectorContainer = ({
  range,
  slots,
  loading,
  gap = JxtSmartSlotContainerGapEnum.REGULAR,
  onSlotSelection,
  autoSelectFirstSlot = false,
}: IJxtSmartSlotContainer) => {
  const { t } = useTranslation();
  const classes = getJxtSmartSlotSelectorContainerClass({ gap });
  const [selectFirstSlot, setSelectFirstSlot] = useState<boolean>(autoSelectFirstSlot);
  const firstSlot = slots.length ? slots[0] : null;

  useEffect(() => {
    if (selectFirstSlot && firstSlot && !loading) {
      onSlotSelection(firstSlot);
      // by using a key attribute on JxtSmartSlotSelectorContainer, the state is reset when the key changes
      setSelectFirstSlot(false);
    }
  }, [selectFirstSlot, firstSlot, loading, onSlotSelection]);

  const handleClick = (s: IQuickTimeSlot): void => {
    onSlotSelection(s);
    setSelectFirstSlot(false);
  };

  const wrapper = (content: JSX.Element | JSX.Element[]) => <div className={classes}>{content}</div>;

  if (loading) {
    return wrapper(<JxtLoader size={36} stroke={6} />);
  }

  if (!slots?.length) {
    return wrapper(<span className="text-neutral-60">{t('this-space-has-no-time-slot-available-this-day')}</span>);
  }

  return wrapper(
    slots.map((s) => (
      <JxtSmartSlotSelector
        key={s.text}
        selected={!!s && isSlotSelected(s, range)}
        onClick={() => {
          handleClick(s);
        }}
      >
        {s.text}
      </JxtSmartSlotSelector>
    ))
  );
};

export default JxtSmartSlotSelectorContainer;
